import Icon1 from "../icons/Icon";

const ListCellName = ({ user, removable, onDelete, icon_name = "user" }) => {
  return (
    <div className="flex flex-row gap-2 w-full p-2">
      {/* User Avatar and Email */}
      <div className="flex flex-row gap-2  items-center w-full">
        <img
          src={
            user?.photo ||
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR2dtSs0-ybB7OnCnfsC1UWgViGQLxAtVx83IPHmxIjh1istqxGhm2sjWOSF1TDN_J-r0&usqp=CAU"
          }
          alt="photo"
          className="h-10 w-10 rounded-full"
        />
        <div className=" h-fit flex flex-col text-h3 items-start rounded-full py-1 w-full">
          <div> {user?.display_name}</div>{" "}
          <div className="text-h6 text-shadow_50">
            {" "}
            {user?.email?.substring(0, 30)}
          </div>
        </div>
      </div>

      {/* Close Icon (Removable functionality) */}
      {removable && (
        <div
          className="cursor-pointer flex justify-end items-center flex-row gap-2"
          onClick={() => onDelete(user)}
        >
          <Icon1
            icon_name="delete"
            height="16px"
            width="16px"
            hover_color={"red"}
            fill={"grey"}
          />
        </div>
      )}
    </div>
  );
};

export default ListCellName;
